import React from "react";
import { array } from "prop-types";

import NewsWithImage from "../../../molecules/NewsWithImage";
import LeftImageRightNews from "../../../molecules/LeftImageRightNews";

import "./organism1.m.css";

const Organism1 = ({ stories = [] }) => {
  if (!stories.length) return null;

  const [leadStory, secondStory] = stories.map(({ story }) => story);

  return (
    <div styleName="wrapper">
      <NewsWithImage story={leadStory} cssStyleName="mediumSize" showExcerpt={true} widths={[400, 950, 450]} />
      <LeftImageRightNews story={secondStory} showExcerpt={false} widths={[200, 250, 200]} />
    </div>
  );
};

Organism1.propTypes = {
  stories: array.isRequired,
};

export default Organism1;
